module.exports = __webpack_public_path__ + "img/eco1.cc418369.png";